const THEME_DIALOG_OPEN = 'THEME_DIALOG_OPEN';
const THEME_DIALOG_CLOSE = 'THEME_DIALOG_CLOSE';
const LOGOUT_DIALOG_OPEN = 'LOGOUT_DIALOG_OPEN';
const LOGOUT_DIALOG_CLOSE = 'LOGOUT_DIALOG_CLOSE';
const ANIME_DELETE_DIALOG_OPEN = 'ANIME_DELETE_DIALOG_OPEN';
const ANIME_DELETE_DIALOG_CLOSE = 'ANIME_DELETE_DIALOG_CLOSE';
const ANIME_DETAIL_DIALOG_OPEN = 'ANIME_DETAIL_DIALOG_OPEN';
const ANIME_DETAIL_DIALOG_CLOSE = 'ANIME_DETAIL_DIALOG_CLOSE';
const SHARE_WATCHLIST_DIALOG_OPEN = 'SHARE_WATCHLIST_DIALOG_OPEN';
const SHARE_WATCHLIST_DIALOG_CLOSE = 'SHARE_WATCHLIST_DIALOG_CLOSE';

export {
  THEME_DIALOG_OPEN,
  THEME_DIALOG_CLOSE,
  LOGOUT_DIALOG_OPEN,
  LOGOUT_DIALOG_CLOSE,
  ANIME_DELETE_DIALOG_OPEN,
  ANIME_DELETE_DIALOG_CLOSE,
  ANIME_DETAIL_DIALOG_OPEN,
  ANIME_DETAIL_DIALOG_CLOSE,
  SHARE_WATCHLIST_DIALOG_OPEN,
  SHARE_WATCHLIST_DIALOG_CLOSE,
};
